import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';

// Pages
import Login from './pages/Login';
import Home from './pages/Home';
import Locations from './pages/Locations';
import LocationForm from './pages/LocationForm';
import LocationsMap from './pages/LocationsMap';
import Orders from './pages/Orders';
import OrderForm from './pages/OrderForm';
import OrderDetail from './pages/OrderDetail';
import GatePasses from './pages/GatePasses';
import Profile from './pages/Profile';
import DeliveryInstructions from './pages/DeliveryInstructions';
import SharedInstructions from './pages/SharedInstructions';
import AccessibilitySettings from './pages/AccessibilitySettings';

import './index.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Public Route (redirect if authenticated)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return isAuthenticated ? <Navigate to="/" /> : children;
};

function AppContent() {
  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/locations" element={<ProtectedRoute><Locations /></ProtectedRoute>} />
          <Route path="/locations/map" element={<ProtectedRoute><LocationsMap /></ProtectedRoute>} />
          <Route path="/locations/new" element={<ProtectedRoute><LocationForm /></ProtectedRoute>} />
          <Route path="/locations/:id/edit" element={<ProtectedRoute><LocationForm /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
          <Route path="/orders/new" element={<ProtectedRoute><OrderForm /></ProtectedRoute>} />
          <Route path="/orders/:id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
          <Route path="/gatepasses" element={<ProtectedRoute><GatePasses /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/delivery-instructions" element={<ProtectedRoute><DeliveryInstructions /></ProtectedRoute>} />
          <Route path="/accessibility-settings" element={<ProtectedRoute><AccessibilitySettings /></ProtectedRoute>} />
          <Route path="/share/instructions/:token" element={<SharedInstructions />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick theme="light" />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
